import { isString } from "lodash";

export { isString };
